export function AddUserToGroups(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/groups`;
}

export function AddUsersToGroup(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/users`;
}

export function BanUser(organizationID: number, groupID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/users/${userID}/ban`;
}

export function Capabilities(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/user-groups/${ID}/capabilities`;
}

export function GroupMemberships(organizationID: number, groupID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/user-groups/${groupID}/${userID}`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/user-groups`;
}

export function Index1(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/groups`;
}

export function RemoveUser(organizationID: number, groupID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/users/${userID}`;
}

export function RemoveUsers(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/users`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/user-groups/${ID}`;
}

export function UpdateRoleCapabilityOverrides(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/user-groups/${ID}/capabilities`;
}

